import * as getters from './getters';
import * as actions from './actions';

export default {
  strict: true,
  state: {
    isFetchingClosings: false,
  },
  getters,
  actions,
  mutations: {
    'stationTemporaryClosing/set': (state, { path, value }) => {
      state[path] = value;
    },
  },
};
